import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { IPartProConversation, IPartProConversationMessagesResponse } from "../models/PartProMessage";

export default function usePartProMessageChain(
  conversation: IPartProConversation | undefined,
  componentName = "usePartProMessageChain"
) {
  const { get, post } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const messages = useQuery(
    ["partproconversation", conversation?.id],
    () => get<IPartProConversationMessagesResponse>(`/partpromessaging/conversation/${conversation?.id}`),
    {
      enabled: conversation != undefined,
    }
  );

  const sendReply = useMutation(
    ({ body }: { body: string }) => post(`/partpromessaging/conversation/${conversation?.id}/send`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["partproconversation", conversation?.id]);
        queryClient.invalidateQueries(["pagedTable", "/partpromessaging/paged"]);
      },
    }
  );

  const markRead = useMutation(
    () => post(`/partpromessaging/conversation/${conversation?.id}/read`, null),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable", "/partpromessaging/paged"]);
      },
    }
  );

  return {
    messages,
    sendReply,
    markRead,
  };
}
